module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.containerStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.data), function(item, i) {
    return _c('div', {
      key: 'skid-' + i,
      ref: "skid",
      refInFor: true,
      staticClass: "dof-skid weex-ct weex-div",
      style: ({
        width: _vm._px2rem(750 + item.right.length * 160 + 'px', 75),
        height: _vm._px2rem(_vm.height + 'px', 75)
      }),
      attrs: {
        "weex-type": "div",
        "data-evt-click": "",
        "data-evt-touchstart": "",
        "data-evt-horizontalpan": "",
        "data-evt-touchend": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "touchstart": function($event) {
          $event.stopPropagation();
          return (function (e) { return !_vm.isAndroid && _vm.onPanStart(e, item, i); })($event)
        },
        "horizontalpan": function (e) { return _vm.isAndroid && _vm.onPanStart(e, item, i); },
        "touchend": function($event) {
          $event.stopPropagation();
          return (function (e) { return _vm.onPanEnd(e, item, i); })($event)
        },
        "weex$tap": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          $event.stopPropagation();
          return _vm.onNodeClick(item, i)
        }
      }
    }, [_c('div', {
      staticClass: "swipe-action-center weex-ct weex-div",
      style: (_vm._px2rem(_vm.styles, 75)),
      attrs: {
        "weex-type": "div"
      }
    }, [_vm._t("default", null, {
      "val": {
        item: item,
        index: i
      }
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "swipe-action-right weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, _vm._l((item.right), function(child, childIdx) {
      return _c('div', {
        key: 'child-' + childIdx,
        ref: "button_small",
        refInFor: true,
        staticClass: "swipe-action-child weex-ct weex-div",
        attrs: {
          "weex-type": "div",
          "data-evt-click": ""
        },
        on: {
          "click": _vm.$stopOuterA,
          "weex$tap": function($event) {
            $event.stopPropagation();
            return _vm.onRightNode(item, child, i)
          }
        }
      }, [(child.text.length <= 3) ? _c('p', {
        staticClass: "swipe-action-text weex-el weex-text",
        style: (_vm._processExclusiveStyle(Object.assign({
          lineHeight: _vm.height + 'px'
        }, child.style || {}), 75, 'text')),
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(child.text))]) : _vm._e(), _vm._v(" "), (child.text.length >= 4) ? _c('div', {
        staticClass: "swipe-action-child weex-ct weex-div",
        style: (_vm._px2rem(Object.assign({
          height: _vm.height + 'px'
        }, child.style || {}), 75)),
        attrs: {
          "weex-type": "div"
        }
      }, [_c('p', {
        staticClass: "swipe-action-text weex-el weex-text",
        style: (_vm._processExclusiveStyle(Object.assign({
          marginTop: _vm.heightChoice + 'px'
        }, child.style || {}), 75, 'text')),
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(child.text.slice(0, child.text.length / 2)))]), _vm._v(" "), _c('p', {
        staticClass: "swipe-action-text weex-el weex-text",
        style: (_vm._processExclusiveStyle(Object.assign({
          marginBottom: _vm.heightChoice + 'px'
        }, child.style || {}), 75, 'text')),
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(child.text.slice(2, child.text.length)))])]) : _vm._e()])
    }), 0)])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45a26c8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45a26c8c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-swipe-list/index.vue
// module id = 601
// module chunks = 0 1